import "./index.css";
import React, { Fragment, createRef } from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import Package from "../../components/Package";
import Popup from "../super_products/components/Popup";
import EditPackage from "../super_products/components/EditPackage";
import { TerritoryOptions } from "../../Constants/retailer";
import MapViewer from "../../components/MapViewer";
import ProductThumbnail from "../../components/Package/components/ProductThumbnail";
import ProductCarousel from "./components/ProductCarousel/index.js";
import ConfirmationModal from "../../components/ConfirmationModal/index.js";
import { IMAGE_UPLOAD, YOUTUBE_URL } from "../../Constants/types.js";
import { getFilePath, uploadFile } from "../../Utils/utils.js";
import ViewButton from "./components/ViewButton/index.js";

class Product extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      packages: [],
      eco_packages: [],
      selectedPackage: null,
      territory: TerritoryOptions[0],
      activeEcoPackages: [],
      isEditingSuperPackageFromBrand: false,
      isMapOpen: false,
      hoveredLocation: { lat: null, lng: null, title: "" },
    };
    this.sliderRef = createRef();
  }
  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username, type } = this.props.location.state;
      const uid = localStorage.getItem("uid");
      this.setState({ username, role, brand, uid, loading: true });
      let packages = [];

      if (type !== "Marketplace lister") {
        let eco_packages = [];
        Firebase.getEcoPackages((res) => {
          let packages_keys = Object.keys(res);
          eco_packages = Object.values(res);
          let array = [];
          eco_packages.map((item, index) => {
            item.id = packages_keys[index];
            const { order } = item;
            array[order] = item;
          });
          this.setState({ eco_packages: array });
        });
      }

      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data.packages) {
          packages = brand_data.packages;
          let packages_keys = Object.keys(packages);
          packages = Object.values(packages);
          let array = [];
          packages.map((item, index) => {
            const { order } = item;
            item.id = packages_keys[index];
            array[order] = item;
          });

          if (type === "Marketplace lister") {
            array = array.filter((item) => item.createdByAdminId === uid);
          }
          this.setState({ packages: array });
        }

        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          white: brand_data.white,
          loading: false,
          activeEcoPackages: brand_data.activeEcoPackages || [],
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
          territory: brand_data.territory || TerritoryOptions[0],
        });
      });
    }
  }
  getFor = (renter_owner) => {
    switch (renter_owner) {
      case "renter":
        return 1;
      case "owner":
        return 2;
      case "both":
        return 0;
      default:
        return 0;
    }
  };
  getContents = (contents) => {
    let str = "";
    contents.map((item) => {
      str += "-" + item + "\n";
    });
    return str;
  };

  addPackage = async (data) => {
    this.setState({ loading: true });

    const { brand, uid } = this.state;
    const packageData = {
      caption: data.caption,
      description: data.description,
      price: data.price,
      productType: data.productType,
      saleType: data.saleType,
      paymentMethod: data.paymentMethod,
      paymentType: data.paymentType,
      splittable: data.splittable,
      brand: brand,
      contents: this.getContents(data.contents),
      isgroup: data.isgroup === "yes" ? 1 : 0,
      media: data.media,
      renter_owner: this.getFor(data.renter_owner),
      createdByAdminId: uid,
    };

    if (data.address) {
      packageData.address = data.address;
    }
    if (data.productLogoFile) {
      const { brand: brandId } = this.props.location.state;
      const path = `packages/${brandId}/images`;
      const logoPath = await uploadFile(data.productLogoFile, path);
      if (logoPath) packageData.productLogo = logoPath;
    }

    await Firebase.addBrandPackage(packageData);
    this.setState({ loading: false });
  };

  editPackage = async (data) => {
    const { brand, selectedPackage, isEditingSuperPackageFromBrand } =
      this.state;

    if (isEditingSuperPackageFromBrand) {
      const { caption } = data;
      this.setState({ loading: true });

      // edit super package name for specific brand purpose
      // we use brandId from real-time DB here but perhaps
      // brand name would be easier to read. Future work?
      const packageData = {
        customNameByBrand: {
          ...selectedPackage.customNameByBrand,
          [brand]: caption,
        },
      };
      try {
        await Firebase.updateEcoPackageById(selectedPackage.id, packageData);
        this.setState({ loading: false });
      } catch (err) {
        this.setState({ loading: false });
        console.error("updateEcoPackageById with custom brand name error", err);
      }
    } else {
      this.setState({ loading: true });

      let packageData = {
        caption: data.caption,
        description: data.description,
        price: data.price,
        productType: data.productType,
        saleType: data.saleType,
        paymentMethod: data.paymentMethod,
        paymentType: data.paymentType,
        splittable: data.splittable,
        address: data.isGeoLocated && data.address ? data.address : null,
        contents: this.getContents(data.contents),
        isgroup: data.isgroup === "yes" ? 1 : 0,
        media: data.media,
        for: this.getFor(data.renter_owner),
      };

      const { brand: brandId } = this.props.location.state;
      const path = `packages/${brandId}/images`;

      // if no logo, add logo to product
      if (!selectedPackage.productLogo && data.productLogoFile) {
        const logoPath = await uploadFile(data.productLogoFile, path);
        if (logoPath) packageData.productLogo = logoPath;

        // if there is already a logo -> replace it
      } else if (selectedPackage.productLogo && data.productLogoFile) {
        // 1. delete old logo
        const path = getFilePath(
          "packages",
          selectedPackage.productLogo,
          IMAGE_UPLOAD
        );
        await Firebase.deleteFile(path);

        // 2. upload new logo
        const logoPath = await uploadFile(data.productLogoFile, path);
        if (logoPath) packageData.productLogo = logoPath;
      }

      // delete logo without replacement (triggers when users click delete X)
      else if (selectedPackage.productLogo && data.logoToDelete) {
        const path = getFilePath("packages", data.logoToDelete, IMAGE_UPLOAD);
        Firebase.deleteFile(path);
        packageData.productLogo = "";
      }

      await Firebase.updateBrandPackageById(
        brand,
        selectedPackage.id,
        packageData
      );
      this.setState({ loading: false });
    }
  };

  showEcoPackages = () => {
    let { eco_packages, activeEcoPackages, white, hex, territory, isMapOpen } =
      this.state;
    const { brand: brandId } = this.props.location.state;

    return eco_packages
      .filter((item) => item.visibility)
      .map((item, index) => {
        const isHovered = this.state.hoveredLocation.id === item.id;
        if (isMapOpen && !item.address) return null;
        return (
          <Fragment key={index}>
            {isMapOpen ? (
              <ProductThumbnail
                productData={item}
                isEcoPackage={true}
                isHovered={isHovered}
              />
            ) : (
              <Package
                brandId={brandId}
                id={index}
                data={{
                  ...item,
                  visibility: activeEcoPackages.find(
                    (activePackage) => activePackage === item.id
                  ),
                }}
                white={white}
                hex={hex}
                territory={territory}
                onClick={() => this.toggleEcoPackage(index)}
                onEdit={() => {
                  this.setState({
                    selectedPackage: item,
                    isEditingSuperPackageFromBrand: true,
                  });
                }}
                isEcoPackage={true}
              />
            )}
          </Fragment>
        );
      });
  };
  showPackages = () => {
    let { packages, territory, hoveredLocation, isMapOpen } = this.state;

    return packages.map((item, index) => {
      const isHovered = hoveredLocation.id === item.id;
      if (isMapOpen && !item.address) return null;
      return (
        <Fragment key={index}>
          {isMapOpen ? (
            <ProductThumbnail
              productData={item}
              isEcoPackage={false}
              isHovered={isHovered}
            />
          ) : (
            <Package
              id={index}
              data={item}
              onClick={() => this.togglePackage(index)}
              onEdit={() => {
                this.setState({
                  selectedPackage: item,
                  isEditingSuperPackageFromBrand: false,
                });
              }}
              territory={territory}
            />
          )}
        </Fragment>
      );
    });
  };
  togglePackage = (index) => {
    const { packages, brand } = this.state;
    let visibility = !packages[index].visibility;
    Firebase.updateBrandPackage(brand, packages[index].id, {
      visibility: visibility,
    });
  };

  toggleEcoPackage = (index) => {
    let { eco_packages, brand, activeEcoPackages } = this.state;
    const ecoPackage = eco_packages.filter((item) => item.visibility)[index];
    if (!ecoPackage) {
      return;
    }

    if (activeEcoPackages.find((item) => item === ecoPackage.id)) {
      Firebase.updateBrandDataById(brand, {
        activeEcoPackages: activeEcoPackages.filter(
          (item) => item !== ecoPackage.id
        ),
      });
    } else {
      Firebase.updateBrandDataById(brand, {
        activeEcoPackages: [...activeEcoPackages, ecoPackage.id],
      });
    }
  };

  deleteAllUploadedMediaFromStorage = async () => {
    const { media } = this.state.selectedPackage;
    if (media) {
      const deletePromises = media.map((item) => {
        if (item && item.mediaType !== YOUTUBE_URL) {
          const path = getFilePath("packages", item.mediaUrl, item.mediaType);
          return Firebase.deleteFile(path);
        }
      });
      await Promise.all(deletePromises);
    }
  };

  removePackage = async () => {
    const { selectedPackage, brand, packages, isEditingSuperPackageFromBrand } =
      this.state;

    if (!selectedPackage) {
      return;
    }
    if (isEditingSuperPackageFromBrand) {
      //delete super package data for specific brand purpose
    } else {
      await this.deleteAllUploadedMediaFromStorage();

      if (selectedPackage.productLogo) {
        const path = getFilePath(
          "packages",
          selectedPackage.productLogo,
          IMAGE_UPLOAD
        );
        await Firebase.deleteFile(path);
      }

      Firebase.deleteBrandPackageById(brand, selectedPackage.id)
        .then(() => {
          this.setState({
            packages: (packages || []).filter(
              (item) => item.id !== selectedPackage.id
            ),
          });
        })
        .catch(() => {
          alert("Something went wrong deleting this product");
        });
    }
  };

  toggleView = (isMapOpen) => this.setState({ isMapOpen: isMapOpen });

  setHoveredLocation = (hoveredLocation) => {
    this.setState({ hoveredLocation: hoveredLocation });
  };

  filterProductsWithAddress = () => {
    const { eco_packages, packages } = this.state;
    // add eco package flag
    const ecoPackages = eco_packages.map((product) => {
      return { ...product, isEcoPackage: true };
    });
    const ecoProductsWithAddress = ecoPackages.filter(
      (product) => product.visibility && product.address
    );
    const productsWithAddress = packages.filter((product) => product.address);
    const allProductsWithAddress = [
      ...productsWithAddress,
      ...ecoProductsWithAddress,
    ];
    return allProductsWithAddress;
  };

  render() {
    const {
      logo,
      brand,
      loading,
      brand_name,
      is_property_brand,
      selectedPackage,
      isEditingSuperPackageFromBrand,
      territory,
      hex,
      white,
      isMapOpen,
    } = this.state;
    const { username, role } = this.props.location.state;
    const allProductsWithAddress = this.filterProductsWithAddress();

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main
          className="products"
          style={{
            backgroundColor: isMapOpen ? "#252e3d" : "",
          }}
        >
          <div className="div_content">
            {loading && (
              <i
                className="fa fa-3x fa-sync fa-spin text-muted"
                style={{
                  position: "fixed",
                  left: "48%",
                  top: "48%",
                }}
              />
            )}
            {!loading && (
              <div className="products__wrapper">
                <div className="products__top-container">
                  <button
                    className="btn btn-secondary products__add-btn"
                    data-toggle="modal"
                    data-target="#package_popup"
                  >
                    + Add a new product
                  </button>
                  <div className="shop__btn-container">
                    <ViewButton
                      label="Detailed list view"
                      mobileLabel="List view"
                      isMapOpen={isMapOpen}
                      onClick={() => this.toggleView(false)}
                      hex={hex}
                      white={white}
                    />
                    <ViewButton
                      label="Map view"
                      mobileLabel="Map view"
                      isMapOpen={!isMapOpen}
                      onClick={() => this.toggleView(true)}
                      hex={hex}
                      white={white}
                      title={
                        allProductsWithAddress.length
                          ? ""
                          : "There is currently no product linked to a location"
                      }
                      isDisabled={!allProductsWithAddress.length}
                    />
                  </div>
                </div>
                {isMapOpen && (
                  <MapViewer
                    productsWithAddress={allProductsWithAddress}
                    setHoveredLocation={this.setHoveredLocation}
                    initialZoom={
                      allProductsWithAddress.length === 1 ? 14 : null
                    }
                  />
                )}
              </div>
            )}
            {!loading && isMapOpen ? (
              <ProductCarousel
                productsWithAddress={allProductsWithAddress}
                hoveredLocation={this.state.hoveredLocation}
                sliderRef={this.sliderRef}
              />
            ) : !loading ? (
              <Fragment>
                {this.showEcoPackages()}
                {this.showPackages()}
              </Fragment>
            ) : null}
          </div>
          <Popup
            addPackage={this.addPackage}
            territory={territory}
            hex={hex}
            white={white}
            brandId={brand}
          />
          <EditPackage
            isEditingSuperPackageFromBrand={isEditingSuperPackageFromBrand}
            onEdit={this.editPackage}
            initialValue={selectedPackage}
            territory={territory}
            hex={hex}
            white={white}
            brandId={brand}
          />
          <ConfirmationModal
            onClick={this.removePackage}
            id="remove_package"
            type="package"
            classNames="products__confirm-btn"
            hex={hex}
            white={white}
          />
        </main>
      </div>
    );
  }
}
export default Product;



// WEBPACK FOOTER //
// ./src/screens/Products/index.js